/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** @module core/modules/array-utils/normalize */

/**
 * @description Makes sure that returned value is always an array.
 * @param {*} input - Input.
 * @returns {Array<*>} Normalized array.
 */
function normalize(input) {
  if (_Array$isArray(input)) {
    return input;
  } else {
    return [input];
  }
}

export { normalize };